module.exports = __webpack_public_path__ + "img/tajikistan.2c10db83.svg";